import { FunctionComponent, ReactNode } from 'react'

import styled, { css } from 'styled-components'

interface ContentListProps {
  title: string
  children: ReactNode[]
}

const StyledWrapper = styled.div`
  ${({
    theme: {
      spacing: { spacing8 },
    },
  }) => css`
    display: flex;
    flex-direction: column;
    gap: ${spacing8};

    width: 100%;
    box-sizing: border-box;
  `}
`

const StyledTitle = styled.h1`
  ${({
    theme: {
      typography: {
        headings: {
          small: { bundledCSS: smallHeadingCSS },
        },
      },
      colors: { textDefault },
    },
  }) => css`
    ${smallHeadingCSS};
    color: ${textDefault};
    text-transform: uppercase;
    margin: 0;
    padding: 0;
  `}
`

const StyledContentItemsWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
`

const ContentList: FunctionComponent<ContentListProps> = ({
  title,
  children,
}) => (
  <StyledWrapper>
    <StyledTitle>{title}</StyledTitle>
    <StyledContentItemsWrapper>{children}</StyledContentItemsWrapper>
  </StyledWrapper>
)

export default ContentList
